import { render, staticRenderFns } from "./EpayLogoForm.vue?vue&type=template&id=6f0f74da&"
import script from "./EpayLogoForm.vue?vue&type=script&lang=js&"
export * from "./EpayLogoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports